module.exports = __webpack_public_path__ + "style/img/Rectangle 30@2x.495fab0d.png";